module.exports = __webpack_public_path__ + "img/list_bg.8a428231.png";